export const timeToMin = (time) => {
    // Разделяем строку времени по символу ":"
    const [hours, minutes] = time.split(':').map(Number); // Преобразуем строки в числа
    // Вычисляем общее количество минут
    return hours * 60 + minutes;
  };